import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';

import '../../_modules/bootstrap';

import vuetify from '../_plugins/vuetify';

// root component
import App from './App.vue';

const createApp = async () => {
  new Vue({
    el: '#app',
    vuetify,
    components: {
      App,
    },
    template: '<App />',
  });
};

createApp();
